/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { SelectionTagDefinitionWithLinks } from '../models/selection-tag-definition-with-links';
@Injectable({
  providedIn: 'root',
})
class SelectionDefinitionsWithLinksService extends __BaseService {
  static readonly SelectionDefinitionsWithLinksGetPath = '/selection-definitions-with-links/{tagDefinitionId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Returns the selection tag definition with links
   * @param params The `SelectionDefinitionsWithLinksService.SelectionDefinitionsWithLinksGetParams` containing the following parameters:
   *
   * - `tagDefinitionId`: GUID of the selection tag definition
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  SelectionDefinitionsWithLinksGetResponse(params: SelectionDefinitionsWithLinksService.SelectionDefinitionsWithLinksGetParams): __Observable<__StrictHttpResponse<SelectionTagDefinitionWithLinks>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/selection-definitions-with-links/${encodeURIComponent(String(params.tagDefinitionId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SelectionTagDefinitionWithLinks>;
      })
    );
  }
  /**
   * Returns the selection tag definition with links
   * @param params The `SelectionDefinitionsWithLinksService.SelectionDefinitionsWithLinksGetParams` containing the following parameters:
   *
   * - `tagDefinitionId`: GUID of the selection tag definition
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  SelectionDefinitionsWithLinksGet(params: SelectionDefinitionsWithLinksService.SelectionDefinitionsWithLinksGetParams): __Observable<SelectionTagDefinitionWithLinks> {
    return this.SelectionDefinitionsWithLinksGetResponse(params).pipe(
      __map(_r => _r.body as SelectionTagDefinitionWithLinks)
    );
  }
}

namespace SelectionDefinitionsWithLinksService {

  /**
   * Parameters for SelectionDefinitionsWithLinksGet
   */
  export interface SelectionDefinitionsWithLinksGetParams {

    /**
     * GUID of the selection tag definition
     */
    tagDefinitionId: string;

    /**
     * Bearer JSON Web Token
     */
    Authorization: string;
  }
}

export { SelectionDefinitionsWithLinksService }